import { selectAuth } from "@redux";
import UserStore from "@Rocket-Innovation/components/store/UserStore";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useLocation } from "react-router-dom";
import styled from "styled-components";

export const PageRedirectToNoCode = () => {
    //page hook
    const hostname = window.location.hostname;
    const prefix = hostname.split(".")[0] as string;
    const history = useHistory();
    const { userInfo, auth } = useSelector(selectAuth);
    const accessToken = auth ?? UserStore((s: any) => s.accessToken);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pathValue = searchParams.get("path");

    useEffect(() => {
        if (!pathValue) {
            window.open(`https://${prefix}.rocket-crm-campaigns.app?token=${accessToken}`, "_self");
        } else {
            window.open(
                `https://${prefix}.rocket-crm-campaigns.app${"/" + pathValue}?token=${accessToken}`,
                "_self"
            );
        }
    }, [accessToken, pathValue]);

    return (
        <StyledContainer>
            {/* <Button
                onClick={() =>
                    window.open(
                        `https://${prefix}.rocket-crm-campaigns.app?token=${accessToken}`,
                        "_blank"
                    )
                }
            >
                {"Redirect to no code"}
            </Button> */}
        </StyledContainer>
    );
};

const StyledContainer = styled.div`
    height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;
